import { Link } from 'react-router-dom'
import { Button, Card, Collapse } from 'reactstrap';
import ModalComponent from './ModalComponent';
import React, { FC, useState } from 'react';
import { CoreLoggedInUser } from '../../models/CoreLoggedInUser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { signOut } from '../../store/AuthAction';
import { useDispatch } from 'react-redux';

interface UserInfoProps {
    user?: CoreLoggedInUser | undefined
}

const UserInfo: FC<UserInfoProps> = (props: UserInfoProps) => {
    const { t } = useTranslation(['common']);
    const [modalHelpInfo, setModalHelpInfo] = useState(false);
    const [isShow, setIsShow] = useState(false);
    const dispatch = useDispatch();

    const toggleModal = () => {

        if (modalHelpInfo) {
            setModalHelpInfo(false);
        }
        else {
            setModalHelpInfo(true); 
        }
    };

    const userRelation = props.user?.relation; 
    const user = props.user; 
    const showHelpInfo = () => {
        if (userRelation === undefined)
            return;
        if (userRelation.hasRelated)
            return;
        if (!userRelation.hasRelated && (userRelation.relations === undefined || userRelation.relations.length === 0)) {
            return (
                <ModalComponent
                    isOpen={modalHelpInfo}
                    header={t('userDisplay.troubleShoot.header', { ns: 'common' })}
                    disabled={false}
                    toggleModal={() => toggleModal()}
                    cancel={t('action.close', { ns: 'common' })}
                >
                    <Card id="user-info2" className="user-modal">
                        <div>
                            <p>{t('userDisplay.troubleShoot.message', { ns: 'common' })} </p>
                            {userRelation.additionInformation !== undefined ? <p>{t('userDisplay.troubleShoot.notFound', { ns: 'common' })} </p> : <p>{t('userDisplay.troubleShoot.noSearch', { ns: 'common' })} </p>}
                        </div>
                            <Collapse  isOpen={isShow}>
                                <div> <pre>{userRelation.additionInformation} </pre></div>
                            </Collapse>
                            <Button  type="button" disabled={userRelation.additionInformation === undefined ? true : false} title={t('userDisplay.troubleShoot.btnTooltip', { ns: 'common' })} color="secondary" style={{ float: 'right' }} onClick={() => setIsShow(!isShow)}>{isShow ? t('userDisplay.troubleShoot.btnCollapse', { ns: 'common' }) : t('userDisplay.troubleShoot.btnOpen', { ns: 'common' })}
                            </Button>
                        </Card>
                </ModalComponent>);
        }
        if (!userRelation.hasRelated && (userRelation.relations !== undefined && userRelation.relations.length > 0)) {
            return (
                <ModalComponent 
                    isOpen={modalHelpInfo}
                    header={t('userDisplay.troubleShoot.header', { ns: 'common' })} 
                    disabled={false}
                    toggleModal={() => toggleModal()}
                    cancel={t('action.close', { ns: 'common' })}
                >
        
                    <Card id="user-info2" className="user-modal">
                        <div>
                            <p>{t('userDisplay.troubleShoot.message', { ns: 'common' })} </p>
                            <p>{t('userDisplay.troubleShoot.notIdentified', { ns: 'common' })} </p>
                        </div>
                        <div>
                            <h5>{t('userDisplay.troubleShoot.resultTitle', { ns: 'common' })}</h5>
                            <ul>
                                {userRelation.relations.sort().map(x => <li key={x.key}> <Link title={t('userDisplay.related.linkTooltip', { ns: 'common' })} to={`/user/${x.key}/information`}> <FontAwesomeIcon icon="user" /> {x.displayname}</Link></li>)}
                            </ul>
                        </div>
                        <Collapse isOpen={isShow}>
                        <pre>{userRelation.additionInformation} </pre>
                        </Collapse>
                        <Button type="button" disabled={userRelation.additionInformation === undefined ? true : false} title={t('userDisplay.troubleShoot.btnTooltip', { ns: 'common' })} color="secondary" style={{ width: '10rem', float: 'right' }} onClick={() => setIsShow(!isShow)}>{isShow ? t('userDisplay.troubleShoot.btnCollapse', { ns: 'common' }) : t('userDisplay.troubleShoot.btnOpen', { ns: 'common' })}</Button>
                        </Card>
                </ModalComponent>);
        }
    }

    return (
        <div className="user-details">
            <div className="mt-3">
            <strong> {user?.displayName}</strong>
                <p>{user?.email}</p>
            </div>
                <div className="mt-3">
                    <strong>{t('userDisplay.permissions', { ns: 'common' })}:</strong>
                     <ul>
                    {user?.roles.sort().map(x => <li key={x}>{t(`permissions.${x}`, { ns: 'common' })}</li>)}
                     </ul>
                </div>

            <div className="mt-3">
                <strong>{t('userDisplay.related.text', { ns: 'common' })}:</strong>
                {user?.relation.hasRelated ?
                    <div >
                        <Link title={t('userDisplay.related.linkTooltip', { ns: 'common' })} to={`/user/${userRelation?.related?.key}/information`}>  <FontAwesomeIcon icon="user" /> {userRelation?.related?.displayname }</Link>
                    </div>
                    : <div >
                        <p> {t('userDisplay.related.notFound', { ns: 'common' })}</p>
                        <Button outline color="primary" className="btn-link" onClick={() => { setModalHelpInfo(true); setIsShow(false); }} > {t('userDisplay.related.btn', { ns: 'common' })}</Button>
                    </div>}
            </div>
            {modalHelpInfo && showHelpInfo()}
            <div className="mt-3">
                <Button className="log-out btn-icon" onClick={() => signOut()(dispatch)}><FontAwesomeIcon icon="sign-in-alt" className="nav_icon" />{t('userDisplay.logOut', { ns: 'common' })}  </Button>
            </div> 
        </div >
    )
}
export default UserInfo

